/**
 * MessageUsersInfoRemapper
 *
 * Round-trips a community-message `messageUsersInfo` nested object between its
 * Firestore wire JSON and a MessageUsersInfoDto.
 *
 * Flutter source: lib/data/models/message_users_info.dart:5-16
 *   (+ generated message_users_info.g.dart:9-19).
 *
 * `MessageUsersInfo` has NO `@JsonKey` overrides — every Dart property name
 * equals its Firestore field (`owner`, `userId`, `userName`). All three are
 * `late String` (required); `fromJson` applies `?? ''` defensive defaults so a
 * partial document does not throw.
 */
import type { MessageUsersInfoDto } from '@/data/dtos/info/messageUsersInfoDto';
import type { JsonObject } from '@/data/types/json';
import type { MessageUsersInfoEntity } from '@/domain/entities/info/messageUsersInfoEntity';

export class MessageUsersInfoRemapper {
  static fromJson(data: JsonObject): MessageUsersInfoDto {
    return {
      owner: (data['owner'] as string | undefined) ?? '',
      userId: (data['userId'] as string | undefined) ?? '',
      userName: (data['userName'] as string | undefined) ?? '',
    };
  }

  static fromJsonList(dataList: JsonObject[]): MessageUsersInfoDto[] {
    return dataList.map(MessageUsersInfoRemapper.fromJson);
  }

  static toJson(dto: MessageUsersInfoDto): JsonObject {
    return {
      owner: dto.owner,
      userId: dto.userId,
      userName: dto.userName,
    };
  }

  /**
   * Map a DTO to its domain entity. `MessageUsersInfo` has no `@JsonKey`
   * overrides and no derived fields, so the entity mirrors the DTO 1:1.
   */
  static toEntity(dto: MessageUsersInfoDto): MessageUsersInfoEntity {
    return {
      owner: dto.owner,
      userId: dto.userId,
      userName: dto.userName,
    };
  }

  /**
   * Map an entity back to its DTO for serialization. Named `toDtoFromEntity`
   * (not `toDto`) to avoid colliding with the JSON-emitting `toJson`.
   */
  static toDtoFromEntity(entity: MessageUsersInfoEntity): MessageUsersInfoDto {
    return {
      owner: entity.owner,
      userId: entity.userId,
      userName: entity.userName,
    };
  }
}
